
import Vue from 'vue/dist/vue.esm'

Vue.component(
  "forms-navigation-tree-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/forms/NavigationTree")
)
